import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import { Button } from 'primereact/button';
import { AssignmentSidebarModalInfo } from './AssignmentSidebarModalInfo';
import { SelectAssignmentModeModal } from '../../../models/Assignment';
import { useAppDispatch } from '../../../redux/hooks';
import { setSelectedSkillAssignment } from '../../../redux/reducers/assignmentSelectedSkillSlice';

interface Props {
  showCreateAssignmentModel: SelectAssignmentModeModal;
  setCreateAssignmentModal: Dispatch<SetStateAction<SelectAssignmentModeModal>>;
  callback?: () => void;
}

export const AssignmentSidebarOpenModal: FC<Props> = ({
  showCreateAssignmentModel,
  setCreateAssignmentModal,
  callback,
}) => {
  const dispatch = useAppDispatch();
  const [renderInfoContent, setRenderInfoContent] = useState(false);
  const [onlyTarget, setOnlyTarget] = useState<boolean | null>(null);
  const handleOptionsToOpenSidebar = () => {
    if (showCreateAssignmentModel.skill && onlyTarget !== null) {
      dispatch(setSelectedSkillAssignment({ ...showCreateAssignmentModel.skill, onlyTarget }));
      setCreateAssignmentModal({ visible: false, skill: null });
    }
  };

  const closeModal = () => {
    setOnlyTarget(null);
    setRenderInfoContent(false);
    setCreateAssignmentModal({ visible: false, skill: null });
    if (callback) {
      callback();
    }
  };

  const openInfoOrSidebar = () => {
    if (
      localStorage.getItem(`NOT_SHOW_CREATE_ASSIGNMENT_INFO_${onlyTarget ? 'TARGET' : 'PATH'}`) ||
      renderInfoContent
    ) {
      handleOptionsToOpenSidebar();
    } else {
      setRenderInfoContent(true);
    }
  };
  const handleCardKeyDown = (value: boolean) => (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setOnlyTarget(value);
    }
  };

  return (
    <Dialog
      className="p-3"
      header="Create assignment"
      visible={showCreateAssignmentModel.visible}
      onHide={() => closeModal()}
      footer={
        <div className="flex justify-content-between w-full">
          <Button
            label="Cancel"
            outlined
            className="border-none"
            onClick={() => setCreateAssignmentModal({ visible: false, skill: null })}
          />
          <Button disabled={onlyTarget === null} label="Continue" onClick={() => openInfoOrSidebar()} />
        </div>
      }
    >
      {!renderInfoContent ? (
        <div className="flex lg:flex-row justify-content-around p-2 w-full flex-column">
          <Card
            pt={{ body: { className: 'h-full' } }}
            className={`${
              onlyTarget ? 'border-primary border-3' : ''
            } hover:border-primary cursor-pointer col-12 lg:col-5 shadow-none text-center border-1 focus-within:border-primary focus-within:border-3`}
          >
            <button
              type="button"
              className="w-full h-full bg-transparent border-none p-0 cursor-pointer flex flex-column align-items-center justify-content-center focus:outline-none"
              aria-pressed={onlyTarget === true}
              onClick={() => setOnlyTarget(true)}
              onKeyDown={handleCardKeyDown(true)}
            >
              <i className="nc_icon-nc_target text-5xl text-primary" />
              <h5 style={{ fontStyle: 'normal' }} className="m-0 p-0">
                Assign a Skill
              </h5>
              <p style={{ fontStyle: 'normal', fontFamily: 'Poppins' }} className="m-0 p-0">
                Assign a skill to students.
              </p>
            </button>
          </Card>
          <Card
            pt={{ body: { className: 'h-full' } }}
            className={`${
              onlyTarget === false ? 'border-primary border-3' : ''
            } hover:border-primary cursor-pointer col-12 lg:col-5 shadow-none text-center border-1 focus-within:border-primary focus-within:border-3`}
          >
            <button
              type="button"
              className="w-full h-full bg-transparent border-none p-0 cursor-pointer flex flex-column align-items-center justify-content-center focus:outline-none"
              aria-pressed={onlyTarget === false}
              onClick={() => setOnlyTarget(false)}
              onKeyDown={handleCardKeyDown(false)}
            >
              <span className="pi pi-compass text-5xl text-primary"></span>
              <h5 style={{ fontStyle: 'normal' }} className="font-semibold m-0 p-0">
                Assign a Skill Pathway
              </h5>
              <p style={{ fontStyle: 'normal', fontFamily: 'Poppins' }} className="mx-1 my-0 p-0 ">
                Assign the skill along with key support skills to help students build understanding.
              </p>
            </button>
          </Card>
        </div>
      ) : (
        onlyTarget !== null && <AssignmentSidebarModalInfo onlyTarget={onlyTarget} />
      )}
    </Dialog>
  );
};
